import ReadReceipt from '@/models/ReadReceipt.js';

export default {
    data: () => ({
        isVisible: false,
        markAsReadConfig: {
            timeout: null,
            model: null,
            modelType: null,
            identifierField: null,
        },
    }),

    computed: {
        markedAsRead() {
            const hasReadReceipt = ReadReceipt.query()
                .where('readable_id', this.markAsReadConfig.model.id)
                .where('readable_type', this.markAsReadConfig.modelType)
                .where('user_id', this.user.id)
                .exists();

            return (
                hasReadReceipt || this.user.id === this.markAsReadConfig.model[this.markAsReadConfig.identifierField]
            );
        },

        canMarkAsRead() {
            return (
                this.isVisible &&
                !this.markedAsRead &&
                this.user.id !== this.markAsReadConfig.model[this.markAsReadConfig.identifierField]
            );
        },
    },

    watch: {
        canMarkAsRead(canMarkAsRead) {
            if (canMarkAsRead) {
                if (this.markAsReadConfig.timeout) {
                    clearTimeout(this.markAsReadConfig.timeout);
                }

                this.markAsReadConfig.timeout = setTimeout(() => {
                    this.markAsReadConfig.model.markAsRead();
                }, 5000);
            } else if (this.markAsReadConfig.timeout) {
                clearTimeout(this.markAsReadConfig.timeout);
                this.markAsReadConfig.timeout = null;
            }
        },
    },

    methods: {
        visibilityChanged(isVisible) {
            // Clear the timeout when the announcement is no longer visible
            if (!isVisible && this.markAsReadConfig.timeout) {
                clearTimeout(this.markAsReadConfig.timeout);
                this.markAsReadConfig.timeout = null;
            }

            this.isVisible = isVisible;
        },
    },
};
